<template>
  <div>
    <div
      v-if="purchasesOrder.status == ORDER_STATUS_DRAFT"
      style="display: inline"
    >
      <badge :type="getBadgeType()">
        {{ $t(`PURCHASES_ORDERS.ORDER_STATUS_${purchasesOrder.status}`) }}
      </badge>
    </div>

    <div
      v-if="purchasesOrder.status == ORDER_STATUS_CANCELED"
      style="display: inline"
    >
      <badge :type="getBadgeType()">
        {{ $t(`PURCHASES_ORDERS.ORDER_STATUS_${purchasesOrder.status}`) }}
      </badge>
    </div>

    <template
      v-if="
        ![ORDER_STATUS_DRAFT, ORDER_STATUS_CANCELED].includes(
          purchasesOrder.status
        )
      "
    >
      <div style="display: inline">
        <badge :type="getInvoicingBadgeType()">
          {{
            $t(
              `PURCHASES_ORDERS.INVOICING_STATUS_${purchasesOrder.invoicing_status}`
            )
          }}
        </badge>
      </div>

      <!-- <div style="display: inline">
        &nbsp;>&nbsp;
        <badge :type="getDeliveryBadgeType()">
          {{
            $t(`PURCHASES_ORDERS.DELIVERY_STATUS_${purchasesOrder.delivery_status}`)
          }}
        </badge>
      </div> -->
    </template>
  </div>
</template>

<script>
import {
  orderStatusesOption,
  ORDER_STATUS_DRAFT,
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_VALIDATED,
  INVOICING_STATUS_PENDING,
  INVOICING_STATUS_PARTIALLY_INVOICED,
  INVOICING_STATUS_INVOICED,
  DELIVERY_STATUS_PENDING,
  DELIVERY_STATUS_PARTIALLY_DELIVERED,
  DELIVERY_STATUS_DELIVERED,
} from "@/constants/orders";

export default {
  name: "purchases-order-status-badge",

  components: {},

  mixins: [],

  props: ["purchasesOrder"],

  data() {
    return {
      statusesOptions: orderStatusesOption,
      ORDER_STATUS_DRAFT: ORDER_STATUS_DRAFT,
      ORDER_STATUS_CANCELED: ORDER_STATUS_CANCELED,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.purchasesOrder.status) {
        case ORDER_STATUS_DRAFT:
          return "primary";
        case ORDER_STATUS_CANCELED:
          return "danger";
        case ORDER_STATUS_VALIDATED:
          return "default";
        case ORDER_STATUS_COMPLETED:
          return "success";
        default:
          break;
      }
      return "default";
    },

    getInvoicingBadgeType() {
      switch (this.purchasesOrder.invoicing_status) {
        case INVOICING_STATUS_PENDING:
          return "default";
        case INVOICING_STATUS_PARTIALLY_INVOICED:
          return "primary";
        case INVOICING_STATUS_INVOICED:
          return "success";
        default:
          break;
      }
      return "default";
    },

    getDeliveryBadgeType() {
      switch (this.purchasesOrder.delivery_status) {
        case DELIVERY_STATUS_PENDING:
          return "default";
        case DELIVERY_STATUS_PARTIALLY_DELIVERED:
          return "primary";
        case DELIVERY_STATUS_DELIVERED:
          return "success";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
